import * as types from '@/store/types'
export default {
    getLoadedStatus: state => {
        return state.loaded
    },
    getCards: state => {
        return state.cards
    },
    cards: state => {
        return state.cards
    },
    cardModelDef: state => {
        return state.cardModelDef
    },
    getCardById: state => id => {
        return state.cards.find(model => model.id === id)
    },
    cardLists: state => {
        return state.cardLists
    },
    getCardListById: state => id => {
        return state.cardLists.find(model => model.id === id)
    },
    cardListModelDef: state => {
        return state.cardListModelDef
    },
    cardSortedInList: state => {
        return state.cardSortedInList
    },
    cardsLoaded: state => {
        return state.cardsLoaded
    },
    cardListsLoaded: state => {
        return state.cardListsLoaded
    },
    unsortedCardsListId: state => {
        return state.unsortedCardsListId
    },
    getCountHiddenCardsLists: state => {
        return state.cardLists.filter(model => model.visible === 0).length
    },
    cardComments: state => {
        return state.cardComments
    },
    getCardCommentById: state => id => {
        return state.cardComments.find(model => model.id === id)
    },
    cardCategories: state => {
        return state.cardCategories
    },
    cardCategoriesLoaded: state => {
        return state.cardCategoriesLoaded
    },
    cardCategoryFormShow: state => {
        return state.cardCategoryFormShow
    },
    cardCategoryModelDef: state => {
        return state.cardCategoryModelDef
    },
    lastLoadedCategoryId: state => {
        return state.lastLoadedCategoryId
    },
    tags: state => {
        return state.tags
    },
    cardTagsInCard: state => {
        return state.cardTagsInCard
    },
    getTagById: state => id => {
        return state.tags.find(model => model.id === id)
    },
    deliveries: state => {
        return state.deliveries
    },
    getOrderById: state => id => {
        return state.cards.find(model => model.id === id)
    },
    getDeliveryById: state => id => {
        return state.deliveries.find(model => model.id === id)
    },
    promos: state => {
        return state.promos
    },
    getPromoById: state => id => {
        return state.promos.find(model => model.id === id)
    }
}
